export const system = 'https://quromedical.co.za';
export const medpraxSystem = 'https://www.medpraxapi.co.za';
export const ampathSystem = 'https://www.ampath.co.za';
export const lancetSystem = 'https://www.lancet.co.za';
export const droppaSystem = 'https://droppergroup.co.za';
export const loincSystem = 'http://loinc.org';
export const fhirObservationInterpretationSystem =
  'http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation';
export const twilioSystem = 'https://www.twilio.com/';
export const iconoirSystem = 'https://iconoir.com';
export const carboneSystem = 'https://carbone.io';
export const googleGemini2 =
  'https://cloud.google.com/vertex-ai/generative-ai/docs/gemini-v2';
